import { View } from '@react-pdf/renderer';
import { MyFleetVessel } from '../../../models/my-fleet.model';
import {
  isNonVesselTypeSpecificProReport,
  ProReportResponse,
  ProVesselTypes,
} from '../../../models/pro.model';
import styles from '../pro-report-pdf-styles';
import NonVesselTypeSpecificRiskTable from './pro-report-pdf-risk-table-components/non-vessel-type-specific-risk-table';
import VesselTypeSpecificRiskTable from './pro-report-pdf-risk-table-components/vessel-type-specific-risk-table';
import VesselDetails from './pro-report-pdf-vessel-details';

interface RiskTableProps {
  report: ProReportResponse;
  vessel: MyFleetVessel | undefined;
}

function RiskTable({ report, vessel }: RiskTableProps) {
  if (!report) return null;

  if (
    vessel &&
    vessel.vessel_type &&
    vessel.vessel_type !== ProVesselTypes.UNKNOWN
  ) {
    return <VesselDetails vessel={vessel} riskLevel={report.risk_level} />;
  }

  if (
    vessel &&
    isNonVesselTypeSpecificProReport(report) &&
    (vessel.vessel_type === undefined ||
      vessel.vessel_type === ProVesselTypes.UNKNOWN)
  ) {
    return (
      <View>
        <VesselDetails vessel={vessel} riskLevel={report.risk_level} />
        <View style={styles.hr} />
        <NonVesselTypeSpecificRiskTable report={report} vessel={vessel} />
      </View>
    );
  }

  return (
    <View>
      {isNonVesselTypeSpecificProReport(report) ? (
        <NonVesselTypeSpecificRiskTable report={report} />
      ) : (
        <VesselTypeSpecificRiskTable report={report} />
      )}
    </View>
  );
}

export default RiskTable;
